import React from 'react';

interface CloseProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
}

const Close: React.FC<CloseProps> = ({
    color = "#3F3F3F",
    width = 20,
    height = 17,
    className
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 17"
            fill="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.68306 1.52373C2.88938 1.31741 3.2239 1.31741 3.43022 1.52373L17.6264 15.7199C17.8327 15.9262 17.8327 16.2608 17.6264 16.4671C17.4201 16.6734 17.0856 16.6734 16.8792 16.4671L2.68306 2.2709C2.47673 2.06457 2.47673 1.73005 2.68306 1.52373Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.37358 16.3169C2.16726 16.1106 2.16726 15.7761 2.37358 15.5698L16.5698 1.3736C16.7761 1.16727 17.1106 1.16727 17.3169 1.3736C17.5233 1.57992 17.5233 1.91444 17.3169 2.12076L3.12075 16.3169C2.91443 16.5233 2.57991 16.5233 2.37358 16.3169Z"
                fill={color}
            />
        </svg>
    );
};

export default Close;
